import React, { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import "../../stylesCss/Register.css";
// Import both mutations
import { useVerifyOtpMutation, useResendOtpMutation } from "../../redux/api/authApi.js";
import toast from "react-hot-toast";

const VerifyOTP = ({ email, onClose }) => {
    const [otp, setOtp] = useState("");

    const [verifyOtp, { isLoading: isVerifying, error: verifyError, isSuccess }] = useVerifyOtpMutation();
    const [resendOtp, { isLoading: isResending, error: resendError, isSuccess: resendSuccess }] = useResendOtpMutation();

    // Handle Verify Success/Error
    useEffect(() => {
        if (isSuccess) {
            toast.success("Account verified successfully!");
            onClose();
        }
        if (verifyError) {
            toast.error(verifyError?.data?.message || "Verification failed");
        }
    }, [isSuccess, verifyError, onClose]);

    // Handle Resend Success/Error
    useEffect(() => {
        if (resendSuccess) {
            toast.success("A new OTP has been sent to your email.");
        }
        if (resendError) {
            toast.error(resendError?.data?.message || "Failed to resend OTP");
        }
    }, [resendSuccess, resendError]);

    const submitHandler = (e) => {
        e.preventDefault();
        verifyOtp({ email, otp });
    };

    const handleResend = () => {
        resendOtp({ email });
    };

    return (
        <div className="register-overlay">
            <div className="register-card">

                <button className="register-close-btn" onClick={onClose}>
                    <FiX size={20} />
                </button>

                <h2 className="register-heading">Verify Account</h2>
                <p style={{ textAlign: "center", marginBottom: "15px", fontSize: "14px" }}>
                    Enter the 6-digit code sent to <strong>{email}</strong>
                </p>

                <form className="register-form" onSubmit={submitHandler}>
                    <label htmlFor="otp">Verification Code</label>
                    <input
                        id="otp"
                        type="text"
                        placeholder="Enter 6-digit OTP"
                        name="otp"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                        maxLength="6"
                        required
                    />

                    <button type="submit" className="register-btn" disabled={isVerifying}>
                        {isVerifying ? "Verifying..." : "Verify"}
                    </button>
                </form>

                {/* Resend OTP Button */}
                <div style={{ textAlign: "center", marginTop: "15px" }}>
                    <button
                        type="button"
                        onClick={handleResend}
                        disabled={isResending}
                        style={{ background: "none", border: "none", color: "blue", cursor: "pointer", textDecoration: "underline" }}
                    >
                        {isResending ? "Sending..." : "Didn't receive a code? Resend"}
                    </button>
                </div>

            </div>
        </div>
    );
};

export default VerifyOTP;